import { render, staticRenderFns } from "./AppointmentTypeItemSettings.vue?vue&type=template&id=4a2785e0&scoped=true&"
import script from "./AppointmentTypeItemSettings.vue?vue&type=script&lang=ts&"
export * from "./AppointmentTypeItemSettings.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentTypeItemSettings.vue?vue&type=style&index=0&id=4a2785e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2785e0",
  null
  
)

export default component.exports